import moment from 'moment';

// Mirrors the API's Raw Exam Data export (ExportHelper.ExportToCSV with sheet "RawExamData"):
// same columns, same order, same header text, and every value written as the same text the
// server produced (dates as MM/dd/yyyy, nulls as empty strings, numbers as plain text).
export const RAW_EXAM_EXPORT_SHEET_NAME = 'RawExamData';

const toText = (value) => (value === null || value === undefined ? '' : String(value));

const toDateText = (value) => {
    if (!value) return '';
    const date = moment.parseZone(value);
    return date.isValid() ? date.format('MM/DD/YYYY') : '';
};

// .NET decimal/long ToString(): never uses exponent notation.
const toNumberText = (value) => {
    if (value === null || value === undefined) return '';
    const number = Number(value);
    if (!Number.isFinite(number)) return String(value);
    const text = String(number);
    return /e/i.test(text)
        ? number.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 })
        : text;
};

export const RAW_EXAM_EXPORT_COLUMNS = [
    { key: 'RecordDate', header: 'Record Date', format: toDateText },
    { key: 'Site', header: 'Facility', format: toText },
    { key: 'Radiologist', header: 'Provider', format: toText },
    { key: 'Subspeciality', header: 'Subspecialty', format: toText },
    { key: 'Priority', header: 'Priority', format: toText },
    { key: 'InternalProcedureCode', header: 'Internal Procedure Code', format: toText },
    { key: 'ProcedureName', header: 'Procedure Name', format: toText },
    { key: 'WorkUnit', header: 'Work Unit', format: toNumberText },
    { key: 'RVU', header: 'RVU', format: toNumberText },
    { key: 'Modality', header: 'Modality', format: toText },
    { key: 'Accession', header: 'Accession', format: toText },
    { key: 'TimeRemaining', header: 'Time Remaining', format: toText },
    { key: 'UnreadDTS', header: 'Unread DTS', format: toText },
    { key: 'FinalDTS', header: 'Final DTS', format: toText },
    { key: 'TATUnreadFinalMinutes', header: 'TAT Unread/Final (Minutes)', format: toNumberText },
    { key: 'Modified_Clario_Site_ID', header: 'Unique Facility ID', format: toText },
    { key: 'NPI', header: 'NPI', format: toText },
];

export const RAW_EXAM_EXPORT_HEADERS = RAW_EXAM_EXPORT_COLUMNS.map((column) => column.header);

export const toRawExamExportRow = (record) =>
    RAW_EXAM_EXPORT_COLUMNS.map((column) => column.format(record?.[column.key]));
